<template>
  <el-group-title title="分包合同清单" class="ccui-group-wrapper">
    <template slot="groupTitle">
      <el-form
        :model="form"
        label-width="100px"
        class="ccui-form"
        style="overflow:visible;"
      >
        <div class="extend-btn">
          <el-button plain type="single-number" @click="addTable">
            新增
          </el-button>
        </div>
        <el-table
          :data="tableData"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="listResouce"
            label="清单来源"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.listResouce"
                placeholder="请输入清单来源"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="collectionObject"
            label="归集对象"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.collectionObject"
                placeholder="请输入归集对象"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="part"
            label="部位"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.part"
                placeholder="请输入部位"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="amountOfSubcontract"
            label="分包量"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.amountOfSubcontract"
                placeholder="请输入分包量"
                clearable
                maxlength="13"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="materialsCode"
            label="物资编码"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.materialsCode"
                placeholder="请输入物资编码"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="materialsName"
            label="物资名称"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.materialsName"
                placeholder="请输入物资名称"
                clearable
                maxlength="100"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="measuringUnit"
            label="计量单位"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.measuringUnit"
                placeholder="请输入计量单位"
                clearable
                maxlength="2"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="totalAmtExcludeTax"
            label="不含税合价（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.totalAmtExcludeTax"
                placeholder="请输入不含税合价（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="unitPriceExcludingTax"
            label="不含税单价（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.unitPriceExcludingTax"
                placeholder="请输入不含税单价（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="unitPriceIncludingTax"
            label="含税单价（元）"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.unitPriceIncludingTax"
                placeholder="请输入含税单价（元）"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="totalAmtIncludeTax"
            label="含税合价"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.totalAmtIncludeTax"
                placeholder="请输入含税合价"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="tax"
            label="含税税额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.tax"
                placeholder="请输入含税税额"
                clearable
                maxlength="20"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="备注"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.remark"
                placeholder="请输入备注"
                clearable
                maxlength="500"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="outstandingQuantity"
            label="未结算数量"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.outstandingQuantity"
                placeholder="请输入未结算数量"
                clearable
                maxlength=""
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="changeNum"
            label="变更数量"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.changeNum"
                placeholder="请输入变更数量"
                clearable
                maxlength=""
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="isAdjustTaxFlag"
            label="是否手动调整税额"
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.isAdjustTaxFlag"
                placeholder="请输入是否手动调整税额"
                clearable
                maxlength="1"
              />
            </template>
          </el-table-column>

          <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "materialsManagementInventory",
  props: {
    responsibility: {
      type: String,
      default: ""
    },
    taxRate: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [{ id: "1" }],
      form: {}
    };
  },
  methods: {
    // 新增
    addTable() {
      this.tableData.push({
        id: this.tableData.length + 1
      });
    },
    // 删除
    delTable(index, row) {
      this.tableData.splice(index, 1);
    }
  }
};
</script>
